export const RegionCodes = Object.freeze({
  US: 'us',
  EU: 'eu',
  AU: 'au'
});

const region_code_key = 'GoFormz.RegionCode';
export function InitializeRegion() {
  // check the path, query string, host, and oidc jwt first before falling back to local storage
  // this allows for navigating across regions after initial setup
  if (TryInitializeFromPath()) {
    return;
  }

  if (TryInitializeFromQueryString()) {
    return;
  }

  if (TryInitializeFromHost()) {
    return;
  }

  if (TryInitializeFromJwt()) {
    return;
  }

  const existingRegionCode = getRegionCode();
  if (!!existingRegionCode) {
    return;
  }

  //default to storing the us
  localStorage.setItem(region_code_key, RegionCodes.US);
}

function TryInitializeFromPath() {
  const matchingRegionCode = getRegionCodeFromPath(window.location.pathname);
  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }

  return false;
}

function TryInitializeFromQueryString() {
  // try to pull from the query string first
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const regionCodeFromQuery = params.get('regionCode') || '';
  const matchingRegionCode = Object.values(RegionCodes).find((rc) => regionCodeFromQuery.toLowerCase() == rc.toLowerCase());

  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }

  return false;
}

function TryInitializeFromHost() {
  // try to pull from the host first
  const host = window.location.host || '';
  const matchingRegionCode = Object.values(RegionCodes).find((rc) => host.toLowerCase().includes(`.${rc.toLowerCase()}.`));
  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }
  return false;
}

function TryInitializeFromJwt() {
  const matchingRegionCode = getRegionCodeFromOidcJwt();

  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }

  return false;
}

function getRegionCodeFromOidcJwt() {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith('oidc.user:')) {
      continue;
    }

    const oidcUser = TryParseJson(localStorage.getItem(key));
    const idToken = oidcUser?.id_token;
    const jwtPayload = idToken ? TryParseJwtPayload(idToken) : null;
    const regionCodeFromJwt = jwtPayload?.region_code || oidcUser?.profile?.region_code || '';
    const matchingRegionCode = Object.values(RegionCodes).find((rc) => regionCodeFromJwt.toLowerCase() === rc.toLowerCase());

    if (matchingRegionCode) {
      return matchingRegionCode;
    }
  }

  return null;
}

function TryParseJson(value: string | null) {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function TryParseJwtPayload(token: string) {
  const segments = token.split('.');
  if (segments.length < 2) {
    return null;
  }

  try {
    const payload = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    const normalizedPayload = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    return JSON.parse(atob(normalizedPayload));
  } catch {
    return null;
  }
}

export function getRegionCodeFromPath(pathname: string) {
  const pathSegments = pathname.split('/').filter(Boolean);
  const possibleRegionCode = pathSegments[0] || '';

  return Object.values(RegionCodes).find((rc) => possibleRegionCode.toLowerCase() === rc.toLowerCase()) || null;
}

export function getRegionCode() {
  return localStorage.getItem(region_code_key) || RegionCodes.US;
}

export function clearRegionCode() {
  localStorage.removeItem(region_code_key);
}
